import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

const FilterBadges = ({ 
  filters, 
  selectedFilter, 
  onFilterPress, 
  style 
}) => {
  return (
    <View style={[styles.filterContainer, style]}>
      {filters.map((filter) => (
        <TouchableOpacity
          key={filter}
          style={[
            styles.filterBadge,
            selectedFilter === filter ? styles.filterBadgeActive : styles.filterBadgeInactive
          ]}
          onPress={() => onFilterPress(filter)}
        >
          <Text style={[
            styles.filterText,
            selectedFilter === filter ? styles.filterTextActive : styles.filterTextInactive
          ]}>
            {filter}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  filterContainer: {
    flexDirection: 'row',
    gap: 8,
    marginBottom: 16,
  },
  filterBadge: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
  },
  filterBadgeActive: {
    backgroundColor: '#3B82F6',
  },
  filterBadgeInactive: {
    backgroundColor: '#F1F5F9',
  },
  filterText: {
    fontSize: 12,
    fontWeight: '500',
    fontFamily: 'Poppins-Medium',
  },
  filterTextActive: {
    color: '#FFFFFF',
  },
  filterTextInactive: {
    color: '#64748B',
  },
});

export default FilterBadges;